export default __webpack_public_path__ + "static/media/tool-icon-shirt-orange-03.a96b9d6c.svg";